import { InfiniteClient } from "./infinite-client";
import { PAYLOAD_SYMBOL } from "./resource-client";
import type { IQuery } from "./utils";

export type WithPayload<T> = T & {
  [PAYLOAD_SYMBOL]: any;
};

export abstract class CursorClient<
  Model,
  Identifier = string,
  QueryParams extends IQuery = IQuery,
> extends InfiniteClient<Model, Identifier, QueryParams> {
  /**
   * for paging/infinite queries, extract the next cursor from the previous payload
   * @param {Object} previousResult
   * @returns {IQuery | undefined}
   */
  protected getNextQuery(
    previousResult: WithPayload<Model[]>,
  ): IQuery | undefined {
    // Some APIs return cursor as { value: string } but expects ?cursor=xxx
    // on requests. Extract the string value to match the expected format.
    const next = previousResult[PAYLOAD_SYMBOL]?.next;
    const cursor = typeof next === "string" ? next : next?.value;
    return cursor ? { cursor } : undefined;
  }
}

export default CursorClient;
